module.exports = __webpack_public_path__ + "assets/img/main-2.caffe9a0.jpg";